const SQUARE_SIZE = 64

export interface MissionSectionProps {
  missionParagraphs: string[]
  title?: string
}

export function MissionSection({ missionParagraphs, title = 'MISSION' }: MissionSectionProps) {
  const mid = Math.ceil(missionParagraphs.length / 2)
  const left = missionParagraphs.slice(0, mid)
  const right = missionParagraphs.slice(mid)
  const paraStyle = {
    textAlign: 'justify' as const,
    textAlignLast: 'left' as const,
    hyphens: 'auto' as const,
  }

  return (
    <section
      className="relative overflow-x-hidden overflow-y-visible w-screen min-w-full -mt-10"
      style={{ marginLeft: 'calc(50% - 50vw)', marginRight: 'calc(50% - 50vw)' }}
    >
      {/* Top white half */}
      <div className="h-[72px] bg-white md:h-[80px]" aria-hidden />

      {/* Bottom black half with content */}
      <div className="relative bg-black pt-6 pb-14 md:pt-4 md:pb-20 lg:pt-6 lg:pb-24">
        {/* Central black and white squares straddling the boundary */}
        <div
          className="absolute left-6 top-0 -translate-y-1/2 flex flex-col md:left-12"
          style={{ width: SQUARE_SIZE, height: SQUARE_SIZE * 2 }}
          aria-hidden
        >
          <div
            className="bg-neutral-900 shrink-0"
            style={{ width: SQUARE_SIZE, height: SQUARE_SIZE }}
          />
          <div className="bg-white shrink-0" style={{ width: SQUARE_SIZE, height: SQUARE_SIZE }} />
        </div>

        <div
          className="relative z-10 mx-auto max-w-4xl pl-6 pr-6 pt-6 md:px-12"
          style={{ marginTop: SQUARE_SIZE - 12 }}
        >
          <div className="mb-12 mt-8 w-full md:mb-14 md:mt-0">
            <h2 className="font-bebas-neue text-3xl font-normal uppercase leading-tight tracking-wide text-[#FF6D2C] sm:text-4xl lg:text-5xl">
              {title}
            </h2>
          </div>
          <div
            className="font-poppins grid w-full min-h-[239px] grid-cols-1 gap-x-[42.65px] text-[15.61px] font-light leading-[170%] text-white sm:grid-cols-2"
            style={paraStyle}
          >
            <div className="flex flex-col items-stretch">
              {left.map((para, i) => (
                <p key={i} className="mb-8 text-inherit last:mb-0" style={paraStyle}>
                  {para}
                </p>
              ))}
            </div>
            <div className="flex flex-col items-stretch">
              {right.map((para, i) => (
                <p key={i} className="mb-8 text-inherit last:mb-0" style={paraStyle}>
                  {para}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
